/**
 * Resource Catalog Types
 *
 * Metadata-only types for organizing resources by server/owner/language/resource_id
 */
// ============================================================================
// ENUMS
// ============================================================================
/**
 * Resource types
 */
export var ResourceType;
(function (ResourceType) {
    ResourceType["SCRIPTURE"] = "scripture";
    ResourceType["NOTES"] = "notes";
    ResourceType["WORDS"] = "words";
    ResourceType["WORDS_LINKS"] = "words-links";
    ResourceType["QUESTIONS"] = "questions";
    ResourceType["ACADEMY"] = "academy";
    ResourceType["OBS"] = "obs";
    ResourceType["OBS_NOTES"] = "obs-notes";
    ResourceType["OBS_WORDS_LINKS"] = "obs-words-links";
    ResourceType["OBS_QUESTIONS"] = "obs-questions";
    /** Synthetic Combined Helps (TN + TWL composition) */
    ResourceType["COMBINED_HELPS"] = "combined-helps";
    /** Synthetic OBS Combined Helps */
    ResourceType["OBS_COMBINED_HELPS"] = "obs-combined-helps";
    ResourceType["AUDIO"] = "audio";
    ResourceType["VIDEO"] = "video";
    ResourceType["ALIGNMENT"] = "alignment";
    ResourceType["UNKNOWN"] = "unknown";
})(ResourceType || (ResourceType = {}));
/**
 * Resource formats
 */
export var ResourceFormat;
(function (ResourceFormat) {
    ResourceFormat["USFM"] = "usfm";
    ResourceFormat["TSV"] = "tsv";
    ResourceFormat["MARKDOWN"] = "markdown";
    ResourceFormat["JSON"] = "json";
    ResourceFormat["ZIP"] = "zip";
    ResourceFormat["AUDIO_MP3"] = "audio/mp3";
    ResourceFormat["VIDEO_MP4"] = "video/mp4";
    ResourceFormat["UNKNOWN"] = "unknown";
})(ResourceFormat || (ResourceFormat = {}));
/**
 * Location types - where resources can be found
 */
export var LocationType;
(function (LocationType) {
    LocationType["BUNDLED"] = "bundled";
    LocationType["PHONE"] = "phone";
    LocationType["SDCARD"] = "sdcard";
    LocationType["WEB"] = "web";
    LocationType["NETWORK"] = "network";
    LocationType["CUSTOM"] = "custom"; // Custom location
})(LocationType || (LocationType = {}));
/**
 * Relation types between resources
 */
export var RelationType;
(function (RelationType) {
    RelationType["ALIGNMENT"] = "alignment";
    RelationType["DEPENDENCY"] = "dependency";
    RelationType["SUPPLEMENT"] = "supplement";
    RelationType["TRANSLATION"] = "translation";
    RelationType["REVISION"] = "revision"; // Revision of this resource
})(RelationType || (RelationType = {}));
/**
 * Resource status
 */
export var ResourceStatus;
(function (ResourceStatus) {
    ResourceStatus["DRAFT"] = "draft";
    ResourceStatus["PUBLISHED"] = "published";
    ResourceStatus["DEPRECATED"] = "deprecated";
})(ResourceStatus || (ResourceStatus = {}));
/**
 * Convert ResourceKey to string path
 */
export function resourceKeyToString(key) {
    return `${key.server}/${key.owner}/${key.language}/${key.resourceId}`;
}
/**
 * Parse string path to ResourceKey
 */
export function parseResourceKey(path) {
    const parts = path.split('/');
    if (parts.length !== 4)
        return null;
    return {
        server: parts[0],
        owner: parts[1],
        language: parts[2],
        resourceId: parts[3],
    };
}
